module.exports = __webpack_public_path__ + "static/media/chart-network.e216fca0.svg";